import React from "react";
import { AnomalyLevel, AnomalyPill } from "../../../components/ui/pill/AnomalyPill";
import { OptionNameValuePair } from "../../../lib/interfaces/types";
import { VerificationAnomalyLevel } from "../../../api/physicalTechnicalVerifications";

export const ANOMALY_LEVEL_UI: Record<VerificationAnomalyLevel, AnomalyLevel> = {
  [VerificationAnomalyLevel.CRITICAL]: AnomalyLevel.CRITICAL,
  [VerificationAnomalyLevel.MODERATE]: AnomalyLevel.MODERATE,
  [VerificationAnomalyLevel.NO_ANOMALY]: AnomalyLevel.NO_ANOMALY,
};

const buildAnomalyOption = (
  anomaly: VerificationAnomalyLevel,
): OptionNameValuePair<string> => {
  const pill = <AnomalyPill anomalyLevel={ANOMALY_LEVEL_UI[anomaly]} />;

  return {
    name: ANOMALY_LEVEL_UI[anomaly],
    value: anomaly,
    display_component: pill,
    selected_display_component: pill,
  };
};

export const ANOMALY_SELECT_OPTIONS: OptionNameValuePair<string>[] = [
  buildAnomalyOption(VerificationAnomalyLevel.CRITICAL),
  buildAnomalyOption(VerificationAnomalyLevel.MODERATE),
  buildAnomalyOption(VerificationAnomalyLevel.NO_ANOMALY),
];
